import React from "react";
import { MasterButton } from "App/Component/ui";
import { instance4 } from "App/constants";
import { isNull, oneMonthBeforeToday, today } from "App/utils/helpers";
import {
  STATUS_OPEN_DRAFT_PEMBELIAN,
  STATUS_PROSES_PEMBELIAN,
  STATUS_SELESAI_PEMBELIAN,
} from "../Pembelian/helpers";
import moment from "moment";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export const urlGet = LIST_URL_WAREHOUSE.pembelianLGS.get;
export const urlAllDaftarPembelianLogistikExport = LIST_URL_WAREHOUSE.pembelianLGS.export;
export const urlDelete = LIST_URL_WAREHOUSE.pembelianLGS.delete;
export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  id: "",
  is_PO: "",
  supplier_id: "",
  gudang_id: "",
  gudang: "Pilih Gudang",
  supplier: "Pilih Supplier",
  kategory_tanggal: "tanggal pembelian",
  tanggal_awal: oneMonthBeforeToday(),
  tanggal_akhir: today(),
  no_po: "",
  no_faktur: "",
  lunas: null,
};

export const getByFilterPembelian = async (
  formFilter,
  pages,
  limit,
  status = "",
  alwaysLunas = false
) => {
  try {
    const defaultFilter = {
      halaman: pages,
      jumlah: limit,
      no_pembelian: formFilter.id,
      supplier_id: formFilter.supplier_id,
      gudang_id: formFilter.gudang_id,
      kategory_tanggal: formFilter.kategory_tanggal,
      tanggal_awal: moment(formFilter.tanggal_awal).format("YYYY-MM-DD"),
      tanggal_akhir: moment(formFilter.tanggal_akhir).format("YYYY-MM-DD"),
      status,
      no_po: formFilter.no_po,
      no_faktur: formFilter.no_faktur,
    };

    const isPoConditial = (str) => {
      if (
        str === "" ||
        str === "undefined" ||
        str === null ||
        str === undefined ||
        str === "2" ||
        str === "3"
      ) {
        return true;
      } else {
        return false;
      }
    };

    const isPO = !isPoConditial(formFilter.is_PO)
      ? {
        is_PO: formFilter.is_PO,
      }
      : {};

    const isLunas = alwaysLunas
      ? {
        lunas: true,
      }
      : isNull(formFilter.lunas)
        ? {}
        : {
          lunas: formFilter.lunas,
        };

    const api = await instance4.post(urlGet, {
      ...defaultFilter,
      ...isPO,
      ...isLunas,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.totalData),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deletePembelianById = async (id) => {
  try {
    const api = await instance4.post(urlDelete, {
      id,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus pembelian",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const getAllLaporanPembelianLogistikExport = async (
  formFilter,
  status = "",
  alwaysLunas = false
) => {
  try {
    const defaultFilter = {
      no_pembelian: formFilter.id,
      supplier_id: formFilter.supplier_id,
      gudang_id: formFilter.gudang_id,
      no_po: formFilter.no_po,
      kategory_tanggal: formFilter.kategory_tanggal,
      tanggal_awal: moment(formFilter.tanggal_awal).format("YYYY-MM-DD"),
      tanggal_akhir: moment(formFilter.tanggal_akhir).format("YYYY-MM-DD"),
      status,
    };

    const isPoConditial = (str) => {
      if (
        str === "" ||
        str === "undefined" ||
        str === null ||
        str === undefined ||
        str === "2" ||
        str === "3"
      ) {
        return true;
      } else {
        return false;
      }
    };

    const isPO = !isPoConditial(formFilter.is_PO)
      ? {
        is_PO: formFilter.is_PO,
      }
      : {};

    const isLunas = alwaysLunas
      ? {
        lunas: true,
      }
      : formFilter.is_PO === "2"
        ? {
          lunas: true,
        }
        : formFilter.is_PO === "3"
          ? { lunas: false }
          : {};

    const validPost = {
      ...defaultFilter,
      ...isPO,
      ...isLunas,
    };
   
    const api = await instance4.post(
      urlAllDaftarPembelianLogistikExport,
      validPost
    );
    const res = api.data;
    if(res.status === 200){
      return {
        state: true,
        message: 'Berhasil',
      };
    }else{
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID PEMBELIAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "idgl",
    disablePadding: false,
    label: "IDGL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "po_id",
    disablePadding: false,
    label: "ID PO / NON PO",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nomorPO",
    disablePadding: false,
    label: "NOMOR PO",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "faktur_no",
    disablePadding: false,
    label: "NO FAKTUR",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "status_lunas",
    disablePadding: false,
    label: "STATUS LUNAS",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nama_gudang",
    disablePadding: false,
    label: "GUDANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama_suplier",
    disablePadding: false,
    label: "SUPPLIER",
    align: "left",
    minWidth: "150px",
  },

  {
    id: "faktur_tgl",
    disablePadding: false,
    label: "TGL FAKTUR",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "jatuhtempo_tgl",
    disablePadding: false,
    label: "TGL JATUH TEMPO",
    align: "left",
    sort: false,
    minWidth: "200px",
  },

  {
    id: "kedatangan_tgl",
    disablePadding: false,
    label: "TGL KEDATANGAN",
    align: "left",
    sort: false,
    minWidth: "200px",
  },

  {
    id: "tagih_tgl",
    disablePadding: false,
    label: "TGL TAGIH",
    align: "left",
    sort: false,
    minWidth: "200px",
  },

  {
    id: "sub_total",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "nilai_tax",
    disablePadding: false,
    label: "TAX",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "nilai_discount",
    disablePadding: false,
    label: "DISC.",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "biayalain",
    disablePadding: false,
    label: "BIAYA LAIN",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "ongkos",
    disablePadding: false,
    label: "BIAYA ONGKOS",
    align: "left",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "potongan",
    disablePadding: false,
    label: "POTONGAN",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "bayar",
    disablePadding: false,
    label: "BAYAR",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "sisa",
    disablePadding: false,
    label: "SISA",
    align: "left",
    sort: false,
    minWidth: "150px",
  },

  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const RenderStatusPembelianBadge = ({ status }) => {
  if (status === STATUS_OPEN_DRAFT_PEMBELIAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Draft"}
        color={"green"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_PROSES_PEMBELIAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Kunci"}
        color={"warning"}
        type='button'
        disabled
      />
    );
  } else if (status === STATUS_SELESAI_PEMBELIAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Selesai"}
        color={"secondary"}
        type='button'
        disabled
      />
    );
  } else {
    return <p> Tidak ditemukan </p>;
  }
};

export const RenderStatusLunasBadge = ({ status }) => {
  return (
    <MasterButton
      style={{ borderRadius: 20 }}
      name={"Lunas"}
      color={"green"}
      type='button'
      disabled
    />
  );
};

export const ListTotalPembelianFetch = async (
  formFilter,
  status = "",
  alwaysLunas = false
) => {
  try {
    const defaultFilter = {
      no_pembelian: formFilter.id,
      supplier_id: formFilter.supplier_id,
      gudang_id: formFilter.gudang_id,
      kategory_tanggal: formFilter.kategory_tanggal,
      lunas: alwaysLunas ? 1 : formFilter.lunas,
      tanggal_awal: moment(formFilter.tanggal_awal).format("YYYY-MM-DD"),
      tanggal_akhir: moment(formFilter.tanggal_akhir).format("YYYY-MM-DD"),
      status,
      no_po: formFilter.no_po,
      no_faktur: formFilter.no_faktur,
    };

    const isPoConditial = (str) => {
      if (
        str === "" ||
        str === "undefined" ||
        str === null ||
        str === undefined ||
        str === "2" ||
        str === "3"
      ) {
        return true;
      } else {
        return false;
      }
    };

    const isPO = !isPoConditial(formFilter.is_PO)
      ? {
        is_PO: formFilter.is_PO,
      }
      : {};

    const isLunas = alwaysLunas
      ? {
        lunas: true,
      }
      : formFilter.is_PO === "2"
        ? {
          lunas: true,
        }
        : formFilter.is_PO === "3"
          ? { lunas: false }
          : {};

    const api = await instance4.post(LIST_URL_WAREHOUSE.pembelianLGS.total, {
      ...defaultFilter,
      ...isPO,
      ...isLunas,
    });
    const res = api.data;
    if (res.status === 200) {
      return res.data[0];
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};